export default __webpack_public_path__ + "7ab61498f16b2cd71fda8a6ec3c9a2b3.svg";